/**
 * Inspire-hub 2 (www.giap.pl)
 *
 * Copyright © GIAP sp.z.o.o. All rights reserved.
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Karol Pawlak <kpa@giap.pl>, September 2022
 */

/* eslint-disable max-len */
/* flow-disable */

import React, { PropTypes } from 'react';
import Button from 'react-bootstrap/lib/Button';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import GrayPanel from '../../components/GrayPanel';
import { connect } from 'react-redux';
import { runService } from '../../actions/eservices';
import PowrotDoListyEuslug from '../../components/PowrotDoListyEuslug';
import EmptyFileDownloader from '../../components/EmptyFileDownloader';
import AttachmentsPanel from '../../components/AttachmentsPanel';
import CreatedServiceNotReady from "../CreatedServiceNotReady/CreatedServiceNotReady";
import { DecisionContainer, PersonalDataContainer } from '../../containers';
import { layoutColorStyle, headerStyle, getThemeFromLocalStorage } from '../../components/utils/utils';
import CustomizedMap from './CustomizedMap';
import history from '../../core/history';
import pans from './panStyle.scss';
import ModalAlert from './ModalAlert';
import _ from 'lodash';
import fetch from '../../core/fetch';
import loadingData from './loading';

import v from './validators';


const btnStyle = {
  borderRadius: 0,
  border: 'none',
  padding: '10px 40px',
  marginLeft: '10px',
};

const sectionsFieldDicts = {};
const sectionsFieldOptions = {};
const validationGroups = [];


class CreatedEservice extends React.Component {
    state = {
        sections: [],
        attachmentsPanel: {
            addPanel: false,
            attachmentsRequired: false,
            maxSizeMB: 70.00,
            formats: [],
            additionalText: '',
          },
        requiresMap: false,
        mapDescription: '',
        requiresUserInfo: false,
        selectedParcels: [],
        selectedRoads: [],
        errors: {},
        errorTitle: '',
        errorText: '',
        showError: false,
        eserviceDistrict: null,
        attachments: null,
        loading: false,
        isMounted: false,
        isReady: true,
    };

    validators = {};

    nextStep = '/eservices/eserviceSummary/';

    setParcels = (parcels) => this.setState({ selectedParcels: parcels });
    setRoads = (roads) => this.setState({ selectedRoads: roads });

    onHide = () => this.setState({ showError: false });

    componentDidMount = () => {
        const colors = getThemeFromLocalStorage();
        this.fetchCreatedServiceData(this.props.serviceInfo.eservice.shortName);
        let sourceStyle = layoutColorStyle;
        let style = {
          color: sourceStyle[colors].color,
          display: 'block',
        };
        if (colors !== 'normal') {
          sourceStyle = headerStyle;
          style = {
            color: sourceStyle[colors].color,
            backgroundColor: sourceStyle[colors].backgroundColor,
            display: 'block',
          };
        }
        this.setState({ colors, sourceStyle, style });
      }

      async fetchCreatedServiceData(shortName) {
        const url = `${process.env.API_URL}/eservices/service/get/${shortName}/`;
        await fetch(url)
          .then(r => r.json())
          .then(resp => {
            const data = resp.data;
            const isReady = data.basicInfo.requiresUserInfo ? data.basicInfo.docxTplAdded && data.basicInfo.xmlTplAdded : data.basicInfo.docxTplAdded;
            if (isReady || this.props.query.viewOnly) {
              const attachmentsData = data.attachmentsPanel;
              const formats = [];

              if (attachmentsData.formatDocx) {
                formats.push('docx');
              }
              if (attachmentsData.formatJpg) {
                formats.push('jpg');
              }
              if (attachmentsData.formatPdf) {
                formats.push('pdf');
              }
              if (attachmentsData.formatZip) {
                formats.push('zip');
              }

              const attachmentsPanel = {
                addPanel: attachmentsData.addPanel,
                attachmentsRequired: attachmentsData.attachmentsRequired,
                maxSizeMB: attachmentsData.maxSizeMB,
                formats: formats,
                additionalText: attachmentsData.additionalText,
              };
              this.setState({
                  isReady,
                  requiresMap: data.basicInfo.requiresMap,
                  mapDescription: data.basicInfo.mapDescription,
                  requiresUserInfo: data.basicInfo.requiresUserInfo,
                  sections: data.sections,
                  attachmentsPanel: attachmentsPanel,
              }, () => this.createSectionsFromData());
            } else {
              this.setState({ isReady });
            }
          });
      }

      createSectionsFromData = () => {
        const data = this.state.sections;
        for (const section of data) {
            const sectionKey = `section${data.indexOf(section)}`;
            section.sectionKey = sectionKey;

            sectionsFieldDicts[sectionKey] = {};
            validationGroups.push(sectionKey);

            const state = {};
            for (const field of section.fields) {
              const fieldState = this.createStateNameForField(section.fields.indexOf(field), sectionKey);

              // pole tekstowe
              if (field.type === 'textarea') {
                if (field.required === 'TAK') {
                  this.validators[fieldState] = [v.NotNull];
                }
                sectionsFieldDicts[sectionKey][fieldState] = {
                  label: field.fieldTitle,
                  editable: true,
                  type: field.type,
                };
                state[fieldState] = null;
              }

              // pole numeryczne
              if (field.type === 'number') {
                this.validators[fieldState] = [v.isNumber];
                if (field.required === 'TAK') {
                  this.validators[fieldState].push(v.NotNull);
                }
                sectionsFieldDicts[sectionKey][fieldState] = {
                  label: field.fieldTitle,
                  editable: true,
                };
                state[fieldState] = null;
              }

              // pole data
              if (field.type === 'Date') {
                this.validators[fieldState] = [v.CheckDate];
                if (field.required === 'TAK') {
                  this.validators[fieldState].push(v.NotNull);
                }
                sectionsFieldDicts[sectionKey][fieldState] = {
                  label: field.fieldTitle,
                  editable: true,
                };
                state[fieldState] = null;
              }

              // pole tak/nie i pole wyboru
              if (['YesNo', 'Select'].includes(field.type)) {
                this.validators[fieldState] = [];
                if (field.required === 'TAK') {
                  this.validators[fieldState].push(v.NotSelected);
                }
                sectionsFieldOptions[sectionKey] = {};
                if (field.type === 'YesNo') {
                  sectionsFieldOptions[sectionKey][fieldState] = [
                    {
                      label: '',
                      value: '',
                      state: fieldState,
                    },
                    {
                      label: 'TAK',
                      value: 'TAK',
                      state: fieldState,
                    },
                    {
                      label: 'NIE',
                      value: 'NIE',
                      state: fieldState,
                    },
                  ];
                }
                else {
                  sectionsFieldOptions[sectionKey][fieldState] = [
                    {
                      label: '',
                      value: '',
                      state: fieldState,
                    },
                  ];
                  for (const option of field.options) {
                    sectionsFieldOptions[sectionKey][fieldState].push(
                      {
                        label: option.optionValue,
                        value: option.optionValue,
                        state: fieldState,
                      },
                    );
                  }
                }

                sectionsFieldDicts[sectionKey][fieldState] = {
                  label: field.fieldTitle,
                  editable: true,
                  type: 'Select',
                  options: sectionsFieldOptions[sectionKey][fieldState]
                };
                state[fieldState] = null;
              }
            }
            this.setState({ [sectionKey]: state });
        }
        this.setState({ sections: data, isMounted: true });
    } 

    createStateNameForField(fieldIndex, sectionKey) {
        return `${sectionKey}_field${fieldIndex}`;
    }

    onChange = (e, group) => {
      const name = e.target.name;
      this.setState(
        {
          [group]: {
            ...this.state[group],
            [name]: e.target.value,
          },
        },
        () => this.validate(group, name),
      );
    };
  
    onChangeSelect = (e, group) => {
      const name = e.state;
      this.setState(
        {
          [group]: {
            ...this.state[group],
            [name]: e.value,
          },
        },
        () => this.validate(group, name),
      );
    }

    onChangeAttachments = (attachments, errorMessage) => {
      const errorText = errorMessage.errorText;
      const errorTitle = errorMessage.errorTitle;
      const showError = errorMessage.showError;
      this.setState({ attachments, errorText, errorTitle, showError });
    }

    validateField = (group, field) => {
      const checks = [];
      if (Object.keys(this.validators).indexOf(field) > -1) {
        for (const validator of this.validators[field]) {
          const check = validator(this.state[group][field]);
          if (check) checks.push(check);
        }
      }
      return checks;
    };
  
    validateGroup = group => {
      const fields = Object.keys(this.state[group]);
      const errors = {};
      for (const f of fields) {
        const checks = this.validateField(group, f);
        errors[f] = checks;
      }
      return errors;
    };
  
    validate = (group, field = null, callback = null) => {
      let newState = null;
      if (field) {
        if (Object.keys(this.validators).indexOf(field) > -1) {
          const checks = this.validateField(group, field);
          newState = {
            errors: {
              ...this.state.errors,
              [field]: checks,
            },
          };
        }
      } else if (group) {
        const errors = this.validateGroup(group);
        newState = { errors };
      } else {
        let errors = {};
        for (const g of validationGroups) {
          const err = this.validateGroup(g);
          errors = { ...errors, ...err };
        }
        newState = { errors: { ...errors } };
      }
      if (newState) {
        if (callback) {
          this.setState(newState, callback);
        } else {
          this.setState(newState);
        }
      }
    };

    validateAttachmentsContent = () => {
      if (this.state.attachments) {
        for (const attachment of this.state.attachments) {
          if (attachment.name.length < 1) return true;
        }
      }
      return false;
    }

    haseErrors = () => {
      for (const key of Object.keys(this.state.errors)) {
        if (this.state.errors[key].length > 0) return true;
      }
      return false;
    };

    showHelp = () => {
      const helpText = 
        <div>
          <p><b>Aby skorzystać z e-usługi:</b></p>
          <p>1. Wybierz działkę/działki na mapie jeżeli e-usługa tego wymaga.</p>
          <p>2. Uzupełnij wszelkie wymagane pola w sekcjach formularza.</p>
          <p>3. Dodaj pliki w sekcji "Załączniki" jeżeli e-usługa tego wymaga.</p>
          <p>4. Kliknij "Uruchom".</p>
          <br />
          <p><b>W przypadku e-usługi niewymagającej logowania:</b></p>
          <p>Dokument zostanie wygenerowany automatycznie - otwarte zostanie okno służące do jego pobrania.</p>
          <br />
          <p><b>W przypadku e-usługi wymagającej logowania:</b></p>
          <p>Zostaniesz automatycznie przekierowany do Podsumowania, gdzie podpiszesz dokument oraz dokonasz opłaty, w przypadku gdy
            e-usługa wymaga płatności.
          </p>
          <br />
          <p><b>Dodatkowo:</b></p>
          <p>Możesz pobrać wzór wniosku, klikając "Pobierz wzór wniosku".</p>
        </div>
      this.setState({
        errorText: helpText,
        errorTitle: <p><b>Jak złożyć wniosek?</b></p>,
        showError: true,
        loading: false,
      });
    }

    postValidation = () => {
      const hasFieldErrors = this.haseErrors();
      if (this.state.requiresMap && this.state.selectedParcels.length === 0) {
        this.setState({
          errorText: 'Nie wybrano działki ewidencyjnej. Prosimy o wskazanie działki',
          errorTitle: 'Błędnie wypełniony formularz',
          showError: true,
          loading: false,
        });
        return;
      }
  
      if (hasFieldErrors) {
        this.setState({
          errorText: 'Uzupełnij pola obowiązkowe.',
          errorTitle: 'Błędnie wypełniony formularz.',
          showError: true,
          loading: false,
        });
        return;
      }
  
      if (this.state.attachmentsPanel.attachmentsRequired && (!this.state.attachments || this.state.attachments.length === 0)) {
        this.setState({
          errorText: 'Wymagane jest dodanie załączników do składanego wniosku',
          errorTitle: 'Brak załączników.',
          showError: true,
          loading: false,
        });
        return;
      }
  
      const hasEmptyAttachment = this.validateAttachmentsContent();
      if (hasEmptyAttachment) {
        this.setState({
          errorText: 'Przynajmniej jeden załącznik jest pusty. Dodaj plik do załączników',
          errorTitle: 'Pusty załącznik.',
          showError: true,
          loading: false,
        });
        return;
      }
  
      const data = this.state.sections;
      const sections = {};
      for (const section of data) {
          const sectionKey = `section${data.indexOf(section)}`;
          sections[sectionKey] = this.state[sectionKey];
      }
      this.props
        .runService(this.props.serviceInfo.eservice.shortName, this.props.district, {
          sections: sections, 
          selectedParcels: this.state.selectedParcels,
          user: {
            ...this.props.serviceInfo.user,
          },
          attachments: this.state.attachments,
        })
        .then(resp => {
          this.setState({
            loading: false }, () =>
            this.redirectToSummary(resp.jobId));
        });
    };
  
    redirectToSummary = (jobId) => {
      if (this.state.requiresUserInfo) {
        window.location.href = `${this.nextStep}${jobId}`;
      } else {
        window.location.href = `${process.env.API_URL}/eservices/getJobApplication/${jobId}`;
      }
      
    };
  
    startService = () => {
      this.validate(null, null, this.postValidation);
    };

    renderMap() {
      return(
        <GrayPanel
          title={'Wybór obszaru'}
        >
          {this.state.mapDescription && <p><b>{this.state.mapDescription}</b></p>}
          <div className="help-desc">
            W celu wybrania przedmiotowej działki lub działek ewidencyjnych należy wykorzystać jeden z dwóch dostępnych sposobów wyboru działki:<br />
            <ol>
            <li> Wybrać obręb ewidencyjny z rozwijalnej listy obrębów, a następnie wpisać numer działki. W celu dodania kolejnej działki należy powtórzyć czynność.</li>
            <li>Wskazać działkę w oknie mapy wykorzystując przycisk <samp>"Wskaż działki na mapie"</samp>. W celu wybrania kilku działek konieczne jest przytrzymanie na klawiaturze klawisza <kbd>CTRL</kbd>.</li>
            </ol>
            Wybór działek można usunąć pojedynczo lub usuwając wszystkie za pomocą przycisku <samp>"Odznacz wszystko"</samp>.
          </div>
          <CustomizedMap
            serviceType={this.props.serviceInfo.eservice.shortName}
            setParcels={this.setParcels}
            setSelectDzialki={this.setSelectDzialki}
            selectedParcels={this.state.selectedParcels}
            obreby={this.props.serviceInfo.precints}
            district={this.props.districts[this.props.prefix]}
            prefix={this.props.prefix}
            mapState={this.props.mapstates[0]}
            settings={this.props.serviceInfo.eservice.mapConfig}
            dokumentType={this.props.serviceInfo.eservice}
          />
        </GrayPanel>
        );
    }

    renderAdditionalText(additionalText) {
      return(
        <p>{additionalText}</p>
      );
    }

    renderSection(section) {
      return(
        <DecisionContainer
          key={section.sectionKey}
          title={section.sectionTitle}
          data={this.state[section.sectionKey]}
          errors={this.state.errors}
          formDict={sectionsFieldDicts[section.sectionKey]}
          onChange={e => this.onChange(e, section.sectionKey)}
          onChangeSelect={e => this.onChangeSelect(e, section.sectionKey)}
          explain_text={e => this.renderAdditionalText(section.additionalText)}
        />
      )
    }

    renderButtons() {
      return(
        <div className="row mobile-row">
          <div className="col-sm-12">
            <PowrotDoListyEuslug position='left' prefix={this.props.prefix} />
            <EmptyFileDownloader
              position="left"
              prefix={this.props.prefix}
              serviceType={this.props.serviceInfo.eservice.shortName}
              isServiceFromCreator={true}
            />
            <button
              type="submit-lg"
              className="btn btn-primary"
              style={{ float: 'right', marginRight: '15px', ...btnStyle }}
              onClick={() => this.setState({ loading: true }, () => this.startService())}
            >
              Uruchom
            </button>
            <button
              type="submit-lg"
              className="btn btn-default"
              style={{ float: 'right', marginRight: '15px', ...btnStyle }}
              onClick={history.goBack}
            >
              Anuluj
            </button>
          </div>
        </div>
      )
    }

    render() {

        return (
          this.state.isReady || this.props.query.viewOnly?
            <div style={{ paddingTop: '20px' }}>
              <div className='col-xs-1 help-button'>
                <Button className="btn btn-primary pull-right" onClick={this.showHelp}>POMOC</Button>
              </div>
              <h3 style={{ textAlign: 'center' }}>
                {this.props.serviceInfo.eservice.title}
              </h3>
              {this.state.requiresUserInfo && <PersonalDataContainer userData={this.props.serviceInfo.user} />}
              {this.state.requiresMap && this.renderMap()}
              {this.state.isMounted && this.state.sections.map((v, i) => {
                  return this.renderSection(v)
                }
                )
              }
              {this.state.isMounted
                &&
              this.state.attachmentsPanel.addPanel
                &&
              <AttachmentsPanel
                onChangeAttachments={this.onChangeAttachments}
                formats={this.state.attachmentsPanel.formats}
                maxSizeMB={this.state.attachmentsPanel.maxSizeMB}
                additionalText={this.state.attachmentsPanel.additionalText}
              />
              }
              <ModalAlert
                title={loadingData.loadingTitle}
                bodyText={loadingData.loadingBody}
                show={this.state.loading}
                name="loadingModal"
                onHide={this.onHide}
                disableButton
              />
              <ModalAlert
                title={this.state.errorTitle}
                bodyText={this.state.errorText}
                show={this.state.showError}
                name="errorModal"
                onHide={this.onHide}
              />
              {!this.props.query.viewOnly && this.renderButtons()}
            </div>
          :
            <CreatedServiceNotReady title={""} />
        )
    }
}

CreatedEservice.propTypes = {
    serviceInfo: PropTypes.object,
    district: PropTypes.object,
  };
  
  const mapState = state => ({
    current_service: state.eservices.current,
    districts: state.district.districts
  });
  
  const mapDispatch = {
    runService,
  };
  
  export default withStyles(pans)(
    connect(
      mapState,
      mapDispatch,
    )(CreatedEservice),
  );
  


// WEBPACK FOOTER //
// src/routes/eservices/CreatedEservice.js